<template>
  <div
    :class="`name-${name}`"
    class="icon-container"
  >
    <template v-if="name === 'LoginIcon'">
    <svg class="icon" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"	 viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve"><path class="st0" d="M49.804,19.581c-16.982,0-30.8,13.817-30.8,30.8s13.817,30.8,30.8,30.8s30.8-13.817,30.8-30.8	S66.787,19.581,49.804,19.581z M20.992,50.381c0-15.888,12.925-28.812,28.812-28.812s28.812,12.925,28.812,28.812	c0,7.342-2.764,14.047-7.302,19.141c-3.651-5.435-9.117-9.145-15.354-10.553c5.151-2.35,8.746-7.535,8.746-13.556	c0-8.217-6.686-14.903-14.903-14.903s-14.903,6.686-14.903,14.903c0,6.16,3.758,11.459,9.1,13.727	c-6.189,1.601-11.642,5.515-15.122,11.017C23.996,64.992,20.992,58.033,20.992,50.381z M49.804,58.329	c-7.122,0-12.916-5.794-12.916-12.916s5.794-12.916,12.916-12.916S62.72,38.292,62.72,45.413S56.926,58.329,49.804,58.329z	 M30.326,71.589c4.217-6.96,11.829-11.273,19.975-11.273c8.011,0,15.276,3.983,19.602,10.68c-5.195,5.067-12.287,8.197-20.099,8.197	C42.3,79.193,35.459,76.307,30.326,71.589z"/></svg>
    </template>

    <template v-if="name === 'LogOutIcon'">
      <svg class="icon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve">
      <g>
        <g>
          <g>
            <path d="M75.696,82.687H41.28c-0.928,0-1.67-0.742-1.67-1.67c0-0.928,0.742-1.67,1.67-1.67h34.415c0.345,0,0.61-0.265,0.61-0.61
              V23.958c0-0.345-0.265-0.61-0.61-0.61H41.28c-0.928,0-1.67-0.742-1.67-1.67c0-0.928,0.742-1.67,1.67-1.67h34.415
              c2.174,0,3.951,1.776,3.951,3.951v54.778C79.646,80.91,77.87,82.687,75.696,82.687z"/>
            <path d="M61.723,51.347c0,0.928-0.742,1.67-1.67,1.67H27.281l10.341,10.341c0.663,0.663,0.663,1.723,0,2.36
              c-0.318,0.318-0.742,0.477-1.167,0.477c-0.424,0-0.848-0.159-1.193-0.477L23.039,53.521c-0.583-0.583-0.901-1.352-0.901-2.148
              s0.318-1.591,0.901-2.148l12.223-12.223c0.663-0.663,1.697-0.663,2.36,0c0.663,0.663,0.663,1.723,0,2.36L27.281,49.703h32.772
              C60.98,49.676,61.723,50.419,61.723,51.347z"/>
          </g>
        </g>
      </g>
      </svg>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'login-svg-icons',
    props: {
      name: {
        type: String,
        required: true
      }
    }
  }
</script>

<style lang="scss" scoped>
.icon-container{
    display:flex;
}
</style>
